export default {
  namespaced: true,
  state: {
    user:null,
    token:null,
    userAvatar:null,
    companyName:null
  },
  mutations: {
    SET_TOKEN: (state, payload) => {
      state.token = payload
    },
    SET_USER: (state, payload) => {
      state.user = payload
    },
    SET_USERAVATAR: (state, payload) => {
      state.userAvatar = payload
    },
    SET_COMPANYNAME: (state, payload) => {
      state.companyName = payload
    }
  },
  actions: {}
}
